import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

class CommonModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  componentDidMount() {
    this.mask = document.createElement('div');
    this.mask.className = 'modal-mask';
    this.mask.style.display = 'none';
    this.mask.addEventListener('click', this.onClose);
    document.body.appendChild(this.mask);
  }

  componentWillUpdate() {
    const { visible } = this.state;
    if (visible) {
      this.mask.style.display = 'block';
      this.renderToDom();
    } else {
      this.mask.style.display = 'none';
      ReactDOM.unmountComponentAtNode(this.mask);
    }

  }

  componentWillUnmount() {
    document.body.removeChild(this.mask);
    ReactDOM.unmountComponentAtNode(this.mask);
  }

  renderToDom() {
    ReactDOM.render(
      <div
        className='mask-content'
      >
        {this.props.children}
      </div>,
      this.mask
    );
  }

  open = () => {
    this.setState({
      visible: true
    });
  }

  onClose = ev => {
    if (ev.target.className.indexOf('modal-mask') < 0) return;
    this.setState({ visible: false });
  }

  render() {
    return (
      <div onClick={this.open} className='modal-trigger'>
        {this.props.trigger}
      </div>
    );
  }
}

export default CommonModal;


// WEBPACK FOOTER //
// ./src/scripts/components/Incubator/CommonModal/index.js